import { Component, EventEmitter, Input, Output } from '@angular/core';
import { StaffService } from '../../../definition/staff/services/staff.service';
import { CaseService } from '../../../case/services/case.services';
import { ParameterService } from '../../../../shared/services/parameter/parameter.service';
import { switchMap } from 'rxjs';
import {TriggerService} from "../../service/triggered.service";

@Component({
  selector: 'app-assign-user-dialog',
  templateUrl: './assign-user-dialog.component.html',
  styleUrls: ['./assign-user-dialog.component.scss']
})
export class AssignUserDialogComponent {

  @Input() visible: boolean = false;
  @Input() caseId!: number;

  @Output() closeDialog = new EventEmitter<void>();
  @Output() done = new EventEmitter<void>();

  staffList: any[] = [];
  filteredStaffList: any[] = [];
  selectedUserId: number | null = null;
  loading: boolean = false;

  positions: { label: string; value: number }[] = [];
  selectedPositions: number[] = []; // Çoklu seçim
  searchTerm: string = ''; // isim-soyisim arama

  constructor(
    private readonly staffService: StaffService,
    private readonly caseService: CaseService,
    private readonly parameterService: ParameterService,
    private readonly triggerService: TriggerService,
  ) {}

  openDialog(caseId: number) {
    this.caseId = caseId;
    this.selectedUserId = null;
    this.selectedPositions = [];
    this.searchTerm = '';

    this.loadStaffList();
    this.loadPositions();

    this.visible = true;

  }

  loadStaffList() {
    this.staffService.getStaffSelectInCase().subscribe({
      next: (response: any) => {
        // value alanı kesin olarak eklendi
        this.staffList = response.map((staff:any) => ({
          ...staff,
          label: `${staff.firstName} ${staff.lastName}`,
          value: staff.id
        }));
        this.applyFilters();
      }
    });
  }

  loadPositions() {
    this.parameterService
      .getValues('data-group', 'position')
      .subscribe((response: any) => {
        this.positions = response.datas?.values.map((data: any) => ({
          label: data.valueObject.name.value,
          value: data.id,
        }));
      });
  }

  applyFilters() {
    this.filteredStaffList = this.staffList.filter(staff => {
      const matchesPosition = this.selectedPositions.length
        ? this.selectedPositions.includes(staff.position?.id)
        : true;
      const matchesSearch = this.searchTerm
        ? staff.label.toLowerCase().includes(this.searchTerm.toLowerCase())
        : true;
      return matchesPosition && matchesSearch;
    });
  }

  onPositionChange() {
    this.applyFilters();
  }

  onSearchChange() {
    this.applyFilters();
  }

  onSelectUser(userId: number) {
    this.selectedUserId = userId;
  }

  confirmSelection() {
    if (!this.selectedUserId) return;
this.loading = true;
    this.caseService.getCaseById(this.caseId).pipe(
      switchMap((caseData: any) => {
        const payload: any = {
          caseId: this.caseId,
          caseType: caseData?.caseType?.id,
          complaint: caseData?.caseInformations?.complaint,
          diagnoses: caseData?.caseInformations?.diagnoses,
          labmedNo: caseData?.caseInformations?.labmedNo,
          memberContractNo: caseData?.caseInformations?.memberContractNo,
          memberFullname: caseData?.caseInformations?.memberFullname,
          memberNo: caseData?.caseInformations?.memberNo,
          protocolNo: caseData?.caseInformations?.protocolNo,
          recordType: caseData?.recordType,
          staff: this.selectedUserId,
          userNote: caseData?.caseInformations?.userNote,
        };
        return this.caseService.setCaseInformations(payload);
      })
    ).subscribe({
      next: res => {
        this.done.emit();
        this.loading = false;
        this.visible = false;
        this.triggerService.triggerTabNavAction('refreshWithOutTeam');
      },
      error: err => this.loading = false
    });
  }

  onClose() {
    this.visible = false;
    this.closeDialog.emit();
  }
}
